import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect, MEDIA_ASSET_STATUS } from '@socialive/common';
import { updateMediaUploadStatus } from '~/store/mediaUpload';
import { fetchUploadedMediaAsset } from '~/store/recordings';

export const effect = createListenerEffect(
  'mediaUpload/fetchNewStreams<Listener>',
  async (action, { dispatch, trigger }) => {
    const { sessionHash } = action.payload;
    await dispatch(fetchUploadedMediaAsset({ trigger, sessionHash }));
  }
);

const { startListening, middleware } = createListenerMiddleware();

export const predicate = ({ type, payload }) =>
  type === updateMediaUploadStatus.type && payload?.status === MEDIA_ASSET_STATUS.COMPLETED;

startListening({
  predicate,
  effect,
});

export default middleware;
